import '@fancyapps/fancybox';

const $ = window.jQuery;

export default class Gamme {

    constructor() {
        this.fancybox();
        this.posProduct();
    }


    fancybox() {
        $('a.plus').fancybox();
    }

    posProduct() {
        $('.sous-gamme-part .single-sg a').each(function (index) {
            let posTop = -(10 * index);
            $(this).children('hover').css('top', posTop);
        });
    }


}
